/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { DRAG_AND_DROP_ICON_STRING, RICH_TEXT_ICON_STRING, CODE_ICON_STRING } from 'cio/services/editor';

import EditorService from 'cio/services/editor';
import TemplateModel from 'cio/models/template';

interface EditorTypeIconArgs {
  template: TemplateModel;
  showMidDot?: boolean;
}

export default class EditorTypeIcon extends Component<EditorTypeIconArgs> {
  @service editor!: EditorService;

  get showMidDot() {
    return this.args.showMidDot ?? true;
  }
  get editorIcon() {
    return this.editor.getIconFor(this.args.template);
  }
  get editorIconTooltipText() {
    let iconString = this.editorIcon;
    if (iconString === DRAG_AND_DROP_ICON_STRING) {
      return 'Drag-and-drop editor';
    } else if (iconString === RICH_TEXT_ICON_STRING) {
      return 'Rich text editor';
    } else if (iconString === CODE_ICON_STRING) {
      return 'Code editor';
    } else {
      return null;
    }
  }
}
